import { Injectable } from "@angular/core";
import { AppConfigService } from "src/app/core/config/config.service";
import { UserAuthActionsUriService } from "./user-auth-action-uri.service";
import { Observable } from "rxjs";
import { HttpClient, HttpParams } from "@angular/common/http";
import {
  Login,
  LoginStepOne,
  LoginStepThree,
  LoginStepTwo,
} from "src/app/core/models/Login.model";
import {
  LoginAssets,
  LoginStepThreeAssets,
  LoginStepTwoAssets,
} from "../models/login-assets.model";

@Injectable({
  providedIn: "root",
})
export class UserAuthActionsGatewayService {
  constructor(
    private userAuthActionsUriService: UserAuthActionsUriService,
    private http: HttpClient,
    private apiConfig: AppConfigService
  ) {}

  public userLogin(user: LoginAssets): Observable<Login> {
    const url = this.userAuthActionsUriService.getLoginUserUri();
    return this.http.post<Login>(url, user);
  }

  public userLoginStepOne(user: LoginAssets): Observable<LoginStepOne> {
    const url = this.userAuthActionsUriService.getLoginUserStepOneUri();
    return this.http.post<LoginStepOne>(url, user);
  }

  userLoginStepTwo(user: LoginStepTwoAssets): Observable<LoginStepTwo> {
    const url = this.userAuthActionsUriService.getLoginUserStepTwoUri();
    return this.http.post<LoginStepTwo>(url, user);
  }

  userLoginStepThree(user: LoginStepThreeAssets): Observable<LoginStepThree> {
    const url = this.userAuthActionsUriService.getLoginUserStepThreeUri();
    return this.http.post<LoginStepThree>(url, user);
  }

  resetPasswordRequest(username, captcha): Observable<any> {
    let data = { username: username, captcha };

    const url = this.userAuthActionsUriService.getRequestResetPasswordUri();
    return this.http.post(url, data);
  }

  verifyResetToken(token: string) {
    let data = { token: token };

    const url = this.userAuthActionsUriService.getVerifyResetTokenUri();
    return this.http.post(url, data);
  }

  resetPassword(data): Observable<any> {
    const url = this.userAuthActionsUriService.getResetPasswordUri();
    return this.http.post(url, data);
  }

  addCustomer(data): Observable<any> {
    const url = this.userAuthActionsUriService.getAddCustomerUri();
    return this.http.post<any>(url, data);
  }

  getSSOToken(data): Observable<any> {
    const url = this.userAuthActionsUriService.getSSOTokenUri();
    let params = new HttpParams();
    for (let field in data) {
      if (data[field]) {
        params = params.append(field, data[field]);
      }
    }
    return this.http.post<any>(url, data);
  }

  acceptMerchantInvite(data): Observable<any> {
    const url = this.userAuthActionsUriService.getAcceptMerchantInvite();
    return this.http.post<any>(url, data);
  }

  acceptNewMerchantInvite(data): Observable<any> {
    const url = this.userAuthActionsUriService.getAcceptNewMerchantInvite();
    return this.http.post<any>(url, data);
  }

  checkInvitationCode(data): Observable<any> {
    const url = this.userAuthActionsUriService.getCheckInvitationCode();
    return this.http.post<any>(url, data);
  }
}
